// Ported from the portal's components/Icons/Avatar.tsx: preset avatar by name, else initials in a hashed colour.
import { avatarFor, colourFor, initials } from "app/utils/avatars";
import styled from "styled-components";

const Wrap = styled.span<{ $size: number; $bg?: string }>`
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  border-radius: 50%;
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  background: ${(p) => p.$bg ?? "transparent"};
  color: #fff;
  font-weight: 700;
  font-size: ${(p) => Math.round(p.$size / 2.4)}px;
  overflow: hidden;
  img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1); }
`;

export default function Avatar({ name, fullName, url, size = 34, className }: { name?: string | null; fullName?: string; url?: string | null; size?: number; className?: string }) {
  const preset = avatarFor(name);
  const src = url || preset;
  if (src) return <Wrap $size={size} className={className}><img src={src} alt={fullName || "avatar"} /></Wrap>;
  return <Wrap $size={size} $bg={colourFor(fullName || "?")} className={className} aria-label={fullName}>{initials(fullName) || "?"}</Wrap>;
}
